import { isEmpty } from 'lodash/fp';
import { useSelector } from 'react-redux';
import getOfferEnds from '@ahmdigital/logic/lib/content/offers/qualified/get-offer-ends';

import { Customer } from '../../../../../selectors/select-customer/types';
import OfferBannerView from '../offer-banner-view';
import selectCart from '../../../../../selectors/select-cart';
import selectTargetSegment from '../../../../../selectors/select-target-segment';
import useGetAllPlaceholders from '../../../logic/use-get-all-placeholders';
import useGetOfferPresaleDetails from '../../../callout/use-get-offer-presale-details';
import type { OfferBannerVariant } from '../..';

type UpsellOfferBannerProps = {
  customer?: Customer;
  variant?: OfferBannerVariant;
};

const UpsellOfferBanner = ({ customer, variant = 'bordered' }: UpsellOfferBannerProps) => {
  const cart = useSelector(selectCart);
  const upsellTargetSegment = useSelector(selectTargetSegment);
  const { loading: placeholdersLoading, placeholders } = useGetAllPlaceholders();
  const { loading: presaleLoading, data: offerPresaleDetails } = useGetOfferPresaleDetails({
    scenario: { product: cart?.product, scale: customer?.scale ?? '' },
    targetSegment: upsellTargetSegment,
  });

  if (
    placeholdersLoading ||
    presaleLoading ||
    !offerPresaleDetails ||
    isEmpty(offerPresaleDetails.offer) ||
    isEmpty(offerPresaleDetails.rewards) ||
    !placeholders
  ) {
    return <OfferBannerView empty />;
  }

  return (
    <OfferBannerView
      offer={offerPresaleDetails.offer}
      placeholders={placeholders}
      // @ts-expect-error - Automatic, Please fix when editing this file: Requires upstream fix of logic lib
      presaleEnd={getOfferEnds(offerPresaleDetails.offer)}
      presaleSentence={offerPresaleDetails.presaleSentence}
      rewards={offerPresaleDetails.rewards}
      variant={variant}
    />
  );
};

export default UpsellOfferBanner;
